import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import store, { AllModuleState } from '@/store';
import { RouteName } from '../routes';

export default function (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  const rootState = (store.state as AllModuleState);
  if (rootState.login.loginInfo) {
    // 已经登陆过,有登录信息
    const info = rootState.login.loginInfo;
    if (to.path !== '/login/invite' && info.inviteEnable && !info.hasInviteCodeDone) {
      // 需要邀请码的用户没有输入邀请码,前往其他页面要跳转回invite
      const originRedirect = to.query.redirectFullPath;
      next({
        path: '/login/invite',
        query: {
          redirectFullPath: originRedirect || to.fullPath,
        },
        replace: true,
      });
    } else if (to.path !== '/login/info' && info.uid === '0' && info.hasInviteCodeDone) {
      // 验证码输入过,但uid为0的新用户,前往其他页面要跳转回info获取uid
      const originRedirect = to.query.redirectFullPath;
      next({
        path: '/login/info',
        query: {
          redirectFullPath: originRedirect || to.fullPath,
        },
        replace: true,
      });
    } else if (to.path === '/login/account') {
      // 如果已经登录，再去登录页面自动跳转main
      // 登陆过的用户不能进入登陆页面
      next({
        path: '/main',
        replace: true,
      });
    } else if (to.path === '/login/invite' && info.hasInviteCodeDone) {
      // 已经输入过验证码的用户跳转到信息编辑页
      next({
        path: '/login/info',
        replace: true,
      });
    } else if (to.path === '/login/info' && info.uid !== '0') {
      // 如果已经登录，且uid不为0，不允许去信息设置页
      next({
        path: '/main',
        replace: true,
      });
    } else if (to.name === RouteName.mainChatPage && to.query.code && to.query.partner) {
      // pc链接携带邀请码,去除无用变量
      const queryObj = { ...to.query };
      delete queryObj.code;
      delete queryObj.partner;
      // 提取邀请码,重拼链接
      next({
        name: RouteName.mainChatPage,
        params: to.params,
        query: {
          ...queryObj,
        },
        replace: true,
      });
    } else {
      next();
    }
  } else {
    if (!to.meta?.auth) {
      next();
    } else {
      // 如果没有登录信息，自动跳转到登录
      next({
        name: RouteName.account,
        query: {
          redirectFullPath: to.fullPath,
        },
        replace: true,
      });
    }
  }
}
